/**
 * 协同指挥
 * 2017-11-10
 * Bai.Zhiming
 */
"use strict";
angular.module("commandMoudle", [
	"commandServiceModule", //协同指挥公用服务
    "commandRouter", //协同指挥路由
    "manageGroupsModule", //分组管理模块
    "reportSummaryModule", //报题汇总
    "topicsSummaryModule", //选题汇总
    "groupAssignmentModule",//任务指派
    "taskSearchMapModule",//任务指派搜索地图指令
]).
controller("commandCtrl", [function() {

}]);